module.exports = __webpack_public_path__ + "static/scale-model-of-laura-ward-riverwalk-plaza-in-fort-lauderdale-florida-fe917c503dbb6021ea6c7eb78f96e053.png";